// Mixins
import Vue from 'vue'
import { Constants } from '@/Constants'
/**
 * gallery
 * @mixin
 *
 * Used to get Products
 */

export default Vue.extend({
  name: 'getProductsMixin',
  methods: {
    getProducts () {
      const data = { ...Constants.getProducts, parameters: [localStorage.session] }
      // eslint-disable-next-line no-undef
      axios.post(Constants.api_url, data).then(res => {
        if (res.data.flag) {
          this.$store.commit('setProductCategories', res.data.data)
        }
      }).catch(e => console.log('getProducts', e))
    }
  }

})
